import jQuery from 'jquery';

function fireConfetti(canvasDom) {
  const myConfetti = window.confetti.create(canvasDom, {
    resize: true,
    useWorker: true,
  });
  // launch from the left
  myConfetti({
    particleCount: 75,
    angle: 60,
    startVelocity: 60,
    spread: 55,
    origin: { x: 0 },
  });
  // and launch a few from the right edge
  myConfetti({
    particleCount: 75,
    angle: 120,
    startVelocity: 60,
    spread: 55,
    origin: { x: 1 },
  });
  setTimeout(() => {
    myConfetti.reset();
  }, 3000);
}

function partyTime(seconds = 5, canvasDom = null) {
  const duration = seconds * 1000;
  const end = Date.now() + duration;
  const myConfetti = window.confetti.create(canvasDom, {
    resize: true,
    useWorker: true,
  });

  (function frame() {
    // launch a few confetti from the left edge
    myConfetti({
      particleCount: 7,
      angle: 60,
      spread: 75,
      origin: { x: 0 },
    });
    // and launch a few from the right edge
    myConfetti({
      particleCount: 7,
      angle: 120,
      spread: 75,
      origin: { x: 1 },
    });

    // keep going until we are out of time
    if (Date.now() > end) {
      setTimeout(() => {
        myConfetti.reset();
      }, 5000);
      return;
    }
    setTimeout(() => {
      frame();
    }, 50);
  })();
}

jQuery(($) => {
  $('.force-frame-redirect-button').on('click', (event) => {
    event.preventDefault();
    window.location.href = $(event.target).attr('href');
  });

  $('#esign-demo-fake-success').on('click', (event) => {
    event.preventDefault();
    const frame = $('iframe.grant-letter')[0];
    frame.src = $(event.target).attr('href');
  });

  if ($('.force-frame-redirect-button').length !== 0) {
    const element = $('.force-frame-redirect-button')[0];
    setTimeout(() => {
      window.location.href = $(element).attr('href');
    }, 5000);
  }

  if ($('#confetti').length !== 0) {
    fireConfetti($('#confetti')[0]);
  }

  $('.confetti-clicker').on('click', () => {
    fireConfetti($('#confetti-click')[0]);
  });

  window.partyTime = partyTime;
});
